module.exports = __webpack_public_path__ + "static/media/Artboard5.7d0777c9.png";